import { lazy } from 'react';

const LazyErrorPage = lazy(() => import('./error-page'));
export default LazyErrorPage;
